/** Grymwyrd Copia italiana per il layout condiviso (TopNav + Footer). */
export const layoutIt = {
  'layout.nav.veil': 'Il Velo',
  'layout.nav.encyclopedia': 'Enciclopedia',
  'layout.nav.world': 'Il Mondo',
  'layout.nav.play': 'Gioca',
  'layout.nav.books': 'Libri e Regole',
  'layout.nav.community': 'Comunità',
  'layout.nav.homeAria': 'Home di {world}',
  'layout.nav.search': 'Cerca l\'enciclopedia',
  'layout.nav.unmute': 'Attiva ambientazione sonora',
  'layout.nav.mute': 'Disattiva ambientazione sonora',
  'layout.nav.coinBalance': 'Saldo monete',
  'layout.nav.signedInAs': 'Accesso effettuato come {name}',
  'layout.nav.enter': 'Entra in {world}',
  'layout.nav.toggleMenu': 'Attiva/disattiva menu',
  'layout.nav.dashboard': 'Il mio {world} ({name})',
  'layout.nav.signOut': 'Esci',

  'layout.footer.hideLinks': 'Nascondi link del sito',
  'layout.footer.showLinks': 'Link e informazioni legali',
  'layout.footer.tagline': 'Il mondo horror-fantasy vivente dove la tua leggenda diventa canone.',
  'layout.footer.explore': 'Esplora',
  'layout.footer.legal': 'Legale',
  'layout.footer.accessibility': 'Accessibilità',
  'layout.footer.encyclopedia': 'Enciclopedia',
  'layout.footer.world': 'Il Mondo',
  'layout.footer.playVtt': 'Gioca (VTT)',
  'layout.footer.books': 'Libri e Regole',
  'layout.footer.terms': 'Condizioni di Servizio',
  'layout.footer.privacy': 'Informativa sulla Privacy',
  'layout.footer.canonRelease': 'Rilascio Presentazione Canone',
  'layout.footer.aiPolicy': 'Politica AI',
  'layout.footer.cookies': 'Preferenze Cookie',
  'layout.footer.copyright': '© 2026 GameCodex',
}
